import i18n from "../../shared/i18n";
import {
  $selectedSupplements,
  resetSelectedSupplements,
} from "./selectedSupplements";
import { $selectedPackages, selectedPackagesApi } from "./selectedPackages";
import {
  $selectedActivities,
  selectedActivitiesApi,
} from "./selectedActivities";
import { countdownApi } from "../shared/countdown";

export const confirmChangeBaseSelections = async (): Promise<boolean> => {
  const supplements = $selectedSupplements.getState();
  const packages = $selectedPackages.getState();
  const activities = $selectedActivities.getState();
  if (
    supplements.length === 0 &&
    packages.length === 0 &&
    activities.length === 0
  ) {
    return true;
  }

  const shouldReset = window.confirm(i18n.t("base:shouldReset.base"));
  if (shouldReset) {
    resetSelectedSupplements();
    await selectedPackagesApi.reset();
    await selectedActivitiesApi.reset();
    countdownApi.stop();
  }
  return shouldReset;
};

export const confirmChangePackages = async (): Promise<boolean> => {
  const supplements = $selectedSupplements.getState();
  if (supplements.length === 0) return true;

  const shouldReset = window.confirm(i18n.t("base:shouldReset.packages"));
  if (shouldReset) resetSelectedSupplements();
  return shouldReset;
};

export const confirmChangeActivities = async (): Promise<boolean> => {
  const supplements = $selectedSupplements.getState();
  if (supplements.length === 0) return true;

  const shouldReset = window.confirm(i18n.t("base:shouldReset.activities"));
  if (shouldReset) resetSelectedSupplements();
  return shouldReset;
};
